module.exports = __webpack_public_path__ + "static/img/login_headeren.3e412da.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login2/login_headeren.png
// module id = 56vS
// module chunks = 0